
import { motion } from "framer-motion";
import React from "react";
import Card from "../components/Card";
import { CardPanel } from "../styled";

const CardTable = ({ controls, face, suit, onDraw, setDescribe, setGuide }) => {
    return (
        <motion.div whileTap={{ scale: 0.97 }} style={{ flex: 8 }}>
            <CardPanel onClick={onDraw}>
                <motion.div
                    whileTap={{ scale: 0.97 }}
                    animate={controls}
                    transition={{ duration: 0.3 }}
                    style={{ aspectRatio: "9/13" }}
                >
                    <Card
                        face={face}
                        suit={suit}
                        setRule={setDescribe}
                        setRuleGuide={setGuide}
                    />
                </motion.div>
            </CardPanel>
        </motion.div>
    );
};

export default CardTable;
